import React, { Component } from 'react';
import FileUploaderBlob from './../../../commons/FileUploaderBlob.js';
import CONF from './../../../config/config.js';


export default class ChangeStatus extends Component {
	isUserAllowed() {
		const user = JSON.parse(localStorage.getItem('user'));
		const emailId = user && user.bradmanUserProfile && user.bradmanUserProfile.emailId;
		return !!emailId && CONF.changeStatusAllowedUsers.includes(emailId);
	}

	render() {
		return(
			<div className="dump-ingestion-wrapper">
				<div className="white-box">
					<div className="page-header-title">
						Change Inventory Status
					</div>
					{this.isUserAllowed() ?
						<div className="top-thirty">
							<FileUploaderBlob url="ingest/inventory-item/status/change"/>
						</div>
						:
						<div className="top-thirty">
							<div className="error-head-text">Access Restricted</div>
							<div className="error-desc-text">You do not have permission to perform this ingestion. Please contact the system administrator if you need access.</div>
						</div>
					}
				</div>
			</div>
		);
	}
}


// WEBPACK FOOTER //
// ./src/screens/InventoryOperations/Components/ChangeStatus.js